import widgets from "styles/widgets";
import listItemStyles from "styles/list-item-styles";
import { useMouseTilt } from "hooks/mouse-tilt.hook";
import { TemplateDto } from "dtos/shard/template.dto";

export default function TemplateItem(props: {
    id: string,
    template?: TemplateDto,
    selected: boolean,
    onClick?: (template?: TemplateDto) => void,
}): JSX.Element
{
    // Actions:
    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.template);
        }
    }
    const [mouseMove, mouseLeave] = useMouseTilt();

    // Styles:
    const widgetClasses = widgets();
    const listItemClasses = listItemStyles({
        create: !!props.template,
        selected: props.selected,
    });
    
    // Return Component:
    return (
        <div
            onClick={() => onClick()}
            onMouseMove={mouseMove}
            onMouseLeave={mouseLeave}
            className={`${listItemClasses.container}`}
        >
            <div className={`${listItemClasses.tile} ${widgetClasses.mouseTilt}`}>
                {props.template ? (<>
                    <div className={`${listItemClasses.title}`}>
                        <span>{props.template.name.replace(props.template.name[0], props.template.name[0].toUpperCase())}</span>
                    </div>
                </>) : (<>
                    <div className={`${listItemClasses.title}`}>
                        <span>{props.id === "create" ? "Create New" : "No"} Template</span>
                    </div>
                </>)}
            </div>
        </div>
    );
}